module.exports = {
      id: "icons:caret-up-usage",
      viewBox: "0 0 8 4",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#icons:caret-up-usage",
      toString: function () {
        return this.url;
      }
    }